module.exports = __webpack_public_path__ + "c3c0bdd495a17e65d45192190047c7a9.MP3";